import React from "react";
import { UISpacedBoxContent } from "../../BuildlingBlocks/UISpacedBoxContent";
import { StoryNode } from "../../StoryBook/StoryData";
import { PropertyEditorText } from "../PropertyEditorText";
import { PropertyEditorInteger } from "../PropertyEditorInteger";
import { PropertyEditorFloat } from "../PropertyEditorFloat";
import { Box } from "@mui/material";
import { PropertyEditorBoolean } from "../PropertyEditorBoolean";
import { PropertyEditorColor } from "../PropertyEditorColor";
import { PropertyEditorDate } from "../PropertyEditorDate";
import { PropertyEditorExpression } from "../PropertyEditorExpression";
import { ExpressionViewEmptyBehavior } from "../../../Expressions/ExpressionView";
import { PropertyEditorImage } from "../PropertyEditorImage";
import { PropertyEditorObjectList } from "../PropertyEditorObjectList";
import { PropertyEditorSelect } from "../PropertyEditorSelect";
import { PropertyEditorTextList } from "../PropertyEditorTextList";
import { PropertyEditorToggleButtons } from "../PropertyEditorToggleButtons";
import { PropertyEditorTypeSelection } from "../PropertyEditorTypeSelection";
import { PropertyEditorVariableSelection } from "../PropertyEditorVariableSelection";
import { StringDataDefinition } from "../../../rule-engine-core/Common/Data/Definitions/StringDataDefinition";
import { getFilledDataDefinition } from "../../DataEditing/Testing/TestData";
import { PropertyEditorTextSizeSelection, PropertyEditorTextStyleSelection } from "../PropertyEditorTextStyleSelection";

class Person {
    name?: string;
    age?: number;
    isAlive?: boolean;
}

let d = {};
export const CombinedPropertyEditors = [
    new StoryNode(
        () => {
            return (
                <Box
                    width={"350px"}
                    overflow={"none"}
                >
                    <UISpacedBoxContent>
                        <PropertyEditorBoolean
                            label={"Boolean"}
                            hint={"hint"}
                            editObject={d}
                            propertyName={"boolean"}
                        />
                        <PropertyEditorColor
                            label={"Color"}
                            hint={"hint"}
                            editObject={d}
                            propertyName={"color"}
                        />
                        <PropertyEditorDate
                            label={"Date"}
                            hint={"hint"}
                            editObject={d}
                            propertyName={"date"}
                        />
                        <PropertyEditorDate
                            label={"Date Time"}
                            hint={"hint"}
                            editObject={d}
                            propertyName={"datetime"}
                            storeTime={true}
                        />
                        <PropertyEditorExpression
                            label={"Expression"}
                            hint={"hint"}
                            editObject={d}
                            propertyName={"exp"}
                        />
                        <PropertyEditorExpression
                            label={"Expression Value First"}
                            emptyBehavior={ExpressionViewEmptyBehavior.VALUE}
                            hint={"hint"}
                            editObject={d}
                            propertyName={"exp"}
                        />
                        <PropertyEditorExpression
                            label={"Expression Variable First"}
                            emptyBehavior={ExpressionViewEmptyBehavior.VARIABLE}
                            hint={"hint"}
                            editObject={d}
                            propertyName={"exp"}
                        />
                        <PropertyEditorFloat
                            label={"Float"}
                            hint={"hint"}
                            editObject={d}
                            propertyName={"float"}
                        />
                        <PropertyEditorImage
                            label={"Image"}
                            hint={"hint"}
                            editObject={d}
                            propertyName={"image"}
                        />
                        <PropertyEditorInteger
                            label={"Integer"}
                            hint={"hint"}
                            editObject={d}
                            propertyName={"int"}
                        />

                        <PropertyEditorObjectList<Person>
                            label={"Object List"}
                            hint={"hint"}
                            editObject={d}
                            propertyName={"object list"}
                            renderItemUI={(i) => {
                                return (
                                    <UISpacedBoxContent>
                                        <PropertyEditorText
                                            editObject={i}
                                            propertyName={"name"}
                                            label={"name"}
                                        />
                                        <PropertyEditorInteger
                                            editObject={i}
                                            propertyName={"age"}
                                            label={"age"}
                                        />
                                        <PropertyEditorBoolean
                                            editObject={i}
                                            propertyName={"isAlive"}
                                            label={"is alive"}
                                        />
                                    </UISpacedBoxContent>
                                );
                            }}
                            getItemName={(i) => i.name || "unknown"}
                            createNewItem={() => new Person()}
                        />
                        <PropertyEditorSelect
                            label={"Select"}
                            hint={"hint"}
                            editObject={d}
                            propertyName={"select"}
                            options={["a", "b", "c"]}
                        />

                        <PropertyEditorText
                            label={"Text"}
                            hint={"hint"}
                            editObject={d}
                            propertyName={"text"}
                        />
                        <PropertyEditorTextList
                            label={"Text List"}
                            hint={"hint"}
                            editObject={d}
                            propertyName={"textList"}
                        />
                        <PropertyEditorTextList
                            label={"Text List Valid Values"}
                            hint={"hint"}
                            editObject={d}
                            propertyName={"textListValidValues"}
                            validValues={["a", "b", "c"]}
                        />

                        <PropertyEditorToggleButtons
                            label={"Toggle Buttons"}
                            hint={"hint"}
                            editObject={d}
                            propertyName={"toggleButtons"}
                        />
                        <PropertyEditorTypeSelection
                            label={"Type Selection"}
                            hint={"hint"}
                            editObject={d}
                            propertyName={"type"}
                        />
                        <PropertyEditorVariableSelection
                            label={"Variable Selection"}
                            hint={"hint"}
                            editObject={d}
                            propertyName={"variable"}
                            allowNew={false}
                            expectedType={new StringDataDefinition()}
                            inputDataFunction={() => getFilledDataDefinition()}
                        />
                        <PropertyEditorTextSizeSelection
                            label={"Text Size"}
                            hint={"hint"}
                            editObject={d}
                            propertyName={"size"}
                        />
                        <PropertyEditorTextStyleSelection
                            label={"Text Style"}
                            hint={"hint"}
                            editObject={d}
                            propertyName={"style"}
                        />
                    </UISpacedBoxContent>
                </Box>
            );
        },
        "Shared",
        "Property Editors",
        "All",
        "With Hint",
    ),
    new StoryNode(
        () => {
            return (
                <Box width={"350px"}>
                    <UISpacedBoxContent>
                        <PropertyEditorBoolean
                            label={"Boolean"}
                            editObject={d}
                            propertyName={"boolean"}
                        />
                        <PropertyEditorColor
                            label={"Color"}
                            editObject={d}
                            propertyName={"color"}
                        />
                        <PropertyEditorDate
                            label={"Date"}
                            editObject={d}
                            propertyName={"date"}
                        />
                        <PropertyEditorDate
                            label={"Date Time"}
                            editObject={d}
                            propertyName={"datetime"}
                            storeTime={true}
                        />
                        <PropertyEditorExpression
                            label={"Expression"}
                            editObject={d}
                            propertyName={"exp"}
                        />
                        <PropertyEditorExpression
                            label={"Expression Value First"}
                            emptyBehavior={ExpressionViewEmptyBehavior.VALUE}
                            editObject={d}
                            propertyName={"exp"}
                        />
                        <PropertyEditorExpression
                            label={"Expression Variable First"}
                            emptyBehavior={ExpressionViewEmptyBehavior.VARIABLE}
                            editObject={d}
                            propertyName={"exp"}
                        />
                        <PropertyEditorFloat
                            label={"Float"}
                            editObject={d}
                            propertyName={"float"}
                        />
                        <PropertyEditorImage
                            label={"Image"}
                            editObject={d}
                            propertyName={"image"}
                        />
                        <PropertyEditorInteger
                            label={"Integer"}
                            editObject={d}
                            propertyName={"int"}
                        />

                        <PropertyEditorObjectList<Person>
                            label={"Object List"}
                            editObject={d}
                            propertyName={"object list"}
                            renderItemUI={(i) => {
                                return (
                                    <UISpacedBoxContent>
                                        <PropertyEditorText
                                            editObject={i}
                                            propertyName={"name"}
                                            label={"name"}
                                        />
                                        <PropertyEditorInteger
                                            editObject={i}
                                            propertyName={"age"}
                                            label={"age"}
                                        />
                                        <PropertyEditorBoolean
                                            editObject={i}
                                            propertyName={"isAlive"}
                                            label={"is alive"}
                                        />
                                    </UISpacedBoxContent>
                                );
                            }}
                            getItemName={(i) => i.name || "unknown"}
                            createNewItem={() => new Person()}
                        />
                        <PropertyEditorSelect
                            label={"Select"}
                            editObject={d}
                            propertyName={"select"}
                            options={["a", "b", "c"]}
                        />

                        <PropertyEditorText
                            label={"Text"}
                            editObject={d}
                            propertyName={"text"}
                        />
                        <PropertyEditorTextList
                            label={"Text List"}
                            editObject={d}
                            propertyName={"textList"}
                        />
                        <PropertyEditorTextList
                            label={"Text List Valid Values"}
                            editObject={d}
                            propertyName={"textListValidValues"}
                            validValues={["a", "b", "c"]}
                        />

                        <PropertyEditorToggleButtons
                            label={"Toggle Buttons"}
                            editObject={d}
                            propertyName={"toggleButtons"}
                        />
                        <PropertyEditorTypeSelection
                            label={"Type Selection"}
                            editObject={d}
                            propertyName={"type"}
                        />
                        <PropertyEditorVariableSelection
                            label={"Variable Selection"}
                            editObject={d}
                            propertyName={"variable"}
                            allowNew={false}
                            expectedType={new StringDataDefinition()}
                            inputDataFunction={() => getFilledDataDefinition()}
                        />
                        <PropertyEditorTextSizeSelection
                            label={"Text Size"}
                            editObject={d}
                            propertyName={"size"}
                        />
                        <PropertyEditorTextStyleSelection
                            label={"Text Style"}
                            editObject={d}
                            propertyName={"style"}
                        />
                    </UISpacedBoxContent>
                </Box>
            );
        },
        "Shared",
        "Property Editors",
        "All",
        "No Hint",
    ),
];
